<div class="main">
  <div class="loader" *ngIf="showLoader">
    <div class="load">
      <mat-spinner></mat-spinner>
    </div>
  </div>
  <div class="section">
    <div class="sectionHeader">
      <div class="title">
        <div class="label">
          {{'VEHICLE.vehTitle' | translate}}
        </div>
        <div class="help" (click)="openAddVehicleVideoLink()">
          <!-- <app-help [helpData]="helpData" ></app-help> -->
          <img _ngcontent-frd-c8="" alt="" src="assets/helpicon.svg" style="width: 17px;margin-top: 3px;">
        </div>
      </div>
      <div class="addVehicle mat-elevation-z4" (click)="openVehicleMapView();" style="width:150px">
        <span class="text">{{'VEHICLE.vehicle_map_view' | translate}}</span>
    </div>
      <div class="addVehicle mat-elevation-z4" (click)="openAddVehicle();">
        <span class="text">{{'VEHICLE.addVehLab' | translate}}</span>
      </div>
      <div class="addVehicle mat-elevation-z4" (click)="openBulkUpload();">
        <span class="text">{{'DRIVERS.bulkDriver' | translate}}</span>
      </div>
      <!-- <div class="addVehicle mat-elevation-z4" (click)="openVehicleMapView();" style="width:150px">
              <span class="text">{{'VEHICLE.vehicle_map_view' | translate}}</span>
            </div> -->
    </div>

    <!-- <div class="vehicle_tracking">
      <div class="vehicle_sec">
          <div class="head_title">{{'VEHICLE.tracking' | translate}} : {{trackingCount}}</div>
          <div class="tracking">
              <div class="card"
                  (click)="vehicleFilters.gpsStatus =item[0] ;tabIndex= item[0]; getVehicles(vehicleFilters)"
                  *ngFor="let item of tracking">
                  
                      <div class="card2" style="display: flex;align-items: center;"  [ngStyle]="{'color':getColor(item[0])}" [ngClass]="{'selected' : tabIndex== item[0]}">
                          <div
                          class="status" [ngStyle]="{'background':getColor(item[0])}">
                              {{item[0] | titlecase}}</div>
                          <div ngClass="count">{{item[1]}}</div>
                      </div>
                  
              </div>
          </div>
      </div>
      <div class="vehicle_sec" style="margin-left: 20px;">
          <div class="head_title">{{'VEHICLE.non_tracking' | translate}} : {{nonTrackingCount}}</div>
          <div class="non_tracking">
              <div class="card" *ngFor="let item of nonTracking;" (click)="vehicleFilters.gpsStatus =item[0] ;tabIndex= item[0];getVehicles(vehicleFilters)" >
                      <div class="card2" style="display: flex;align-items: center;" [ngStyle]="{'color':getColor(item[0])}" [ngClass]="{'selected' : tabIndex== item[0]}"
                          >
                              <div class="status" [ngStyle]="{'background':getColor(item[0])}">
                              {{item[0]=='noData'?'No Data':item[0] | titlecase}}</div>
                          <div ngClass="count">{{item[1]}}</div>
                      </div>
              </div>
          </div>
      </div>

  </div> -->
    <div class="filter">
      <div class="container">
        <div class="search">
          <div class="inputSearch">
            <input class="inputSelect" type="text" [(ngModel)]="filters.vehicleNumber"
              [placeholder]="'VEHICLE.vehicleNo' | translate" (keyup)="searchFilter(filters.vehicleNumber, 'number');">
            <i class="material-icons clearIcon" *ngIf="filters.vehicleNumber"
              (click)="filters.vehicleNumber = ''; clearFilter('number');">
              clear </i>
          </div>
        </div>
        <div class="search">
          <div class="inputSearch">
            <div class="inputSelect">
              <mat-select (closed)="searchFilter(filters.vehicleType, 'type')" multiple
                [placeholder]="'VEHICLE.vehicleType' | translate" [(ngModel)]="filters.vehicleType">
                <mat-option *ngFor="let vehicle of allVehicles" (onSelectionChange)="selectVehicleType(vehicle, $event)"
                  [value]="vehicle._id">
                  {{vehicle.name}}
                </mat-option>
              </mat-select>
            </div>
          </div>
        </div>
        <div class="search">
          <div class="inputSearch">
            <div class="inputSelect">
              <mat-select (closed)="searchFilter(filters.dedicatedTo, 'dedicated_to')"
                [placeholder]="'Dedicated To' | translate" [(ngModel)]="filters.dedicatedTo">
                <mat-option *ngFor="let shipper of shippersArr" [value]="shipper._id">
                  {{shipper.name}}
                </mat-option>
              </mat-select>
            </div>
          </div>
        </div>
        <div class="search" style="width: 65%;">
          <div class="inputSearch">
            <mat-radio-group aria-label="Select an option">
              <mat-radio-button value="all" [checked]="true"
                (click)="vehicleFilters.in_maintainance = false;vehicleFilters.in_use = false;getVehicles(vehicleFilters)">
                {{'VEHICLE.all_vehicles' | translate}}</mat-radio-button>
              <mat-radio-button value="in_maintainance"
                (click)="vehicleFilters.in_maintainance = true;vehicleFilters.in_use = false; getVehicles(vehicleFilters)">
                {{'VEHICLE.in_maintenance' | translate}}</mat-radio-button>
              <mat-radio-button value="in_use"
                (click)="vehicleFilters.in_maintainance = false;vehicleFilters.in_use = true;getVehicles(vehicleFilters)">
                {{'VEHICLE.in_use' | translate}}</mat-radio-button>
            </mat-radio-group>
          </div>
        </div>
      </div>
    </div>
    <div class="table">
      <table mat-table *ngIf="vehicleList && vehicleList.filteredData.length;else noVehicles"
        [dataSource]="vehicleList.filteredData">
        <ng-container matColumnDef="slno">
          <th mat-header-cell *matHeaderCellDef>
            {{'VEHICLE.slno' | translate}}
          </th>
          <td mat-cell *matCellDef="let element">
            {{element.index}}</td>
        </ng-container>
        <ng-container matColumnDef="vehicleType">
          <th mat-header-cell *matHeaderCellDef>
            {{'VEHICLE.vehicleType' | translate}}
          </th>
          <td mat-cell *matCellDef="let element">
            <div class="value">
              <span>
                <img src="assets/atach-driver.svg" alt="" *ngIf="element.attached" style="width: 20px;"
                  title="{{'VEHICLE.attach_driver_title' | translate}}">
              </span>
              <span>
                {{element.vehicle.name}} - {{element.capacity ? element.capacity : element.vehicle.capacity}} ({{'ADD_VEHICLE.tonage' | translate}})
              </span>
            </div>
            <div class="value">
              <span>
                <a [href]="element.vehicle_pic" *ngIf="element.vehicle_pic">
                  <mat-icon class="icons" title="{{'VEHICLE.registration_id_title' | translate}}">attach_file</mat-icon>
                </a>
              </span>
              <span *ngIf="element.maintenance">
                <img src="assets/VehicleMaintenance.svg" alt="" style="width: 20px;"
                  title="{{'VEHICLE.in_maintenance' | translate}}">
              </span>
              <span>
                <span style="cursor: pointer;" *ngIf="element.last_location_address">
                  <img src="assets/last.png" f style="width: 15px;" alt="last location" title="{{element.last_location_address}}">
                </span>
                {{element.vehicleNumber}}
                <img src="assets/icons8-lease-30.png" *ngIf="element.transporter" f style="width: 15px;" alt="">
              </span>
            </div>
          </td>
        </ng-container>
        <ng-container matColumnDef="dedicatedTo">
          <th mat-header-cell *matHeaderCellDef>
            {{'VEHICLE.dedicatedTo' | translate}}
          </th>
          <td mat-cell *matCellDef="let element">
            <span>
              {{element.dedicated_to}}
            </span>
          </td>
        </ng-container>
        <ng-container matColumnDef="cardPAN">
          <th mat-header-cell *matHeaderCellDef>
            <div class="value">
              Card PAN
            </div>
          </th>
          <td mat-cell *matCellDef="let element">
            {{element.cardPAN || 'N/A'}}
          </td>
        </ng-container>
        <ng-container matColumnDef="status">
          <th mat-header-cell *matHeaderCellDef>
            <div class="value">
              {{'VEHICLE.status' | translate}}
            </div>
          </th>
          <td mat-cell *matCellDef="let element">
            <span [ngClass]="{'online':element.trip_status == 'On Shipment','offline':element.trip_status == 'Free'}">
              {{element.trip_status}}
            </span>
          </td>
        </ng-container>
        <ng-container matColumnDef="driver_details">
          <th mat-header-cell *matHeaderCellDef>
            <div class="value">
              {{'VEHICLE.driver_status' | translate}}
            </div>
          </th>
          <td mat-cell *matCellDef="let element">
            <div class="value" *ngIf="element.driverName">
              {{element.driverName}}
              <span *ngIf="element.attached_drivers_array && element.attached_drivers_array.length > 1"
                title="{{element.attached_drivers_name}}">
                + {{element.attached_drivers_array.length - 1}} more
              </span>
            </div>
            <div class="value" *ngIf="element.driverMobile">
              {{element.driverMobile}}
            </div>
            <div class="value" *ngIf="!element.driverMobile && !element.driverName">
              --
            </div>
          </td>
        </ng-container>
        <!-- <ng-container matColumnDef="vehicle_condition">
                  <th mat-header-cell *matHeaderCellDef>
                      <div class="value">
                        {{'VEHICLE.vehicle_condition' | translate}}
                      </div>
                  </th>
                  <td mat-cell *matCellDef="let element">

                  </td>
                </ng-container>
                <ng-container matColumnDef="fuel_consumption">
                  <th mat-header-cell *matHeaderCellDef>
                      <div class="value">
                        {{'VEHICLE.fuel_consumption' | translate}}
                      </div>
                  </th>
                  <td mat-cell *matCellDef="let element">

                  </td>
                </ng-container>
                <ng-container matColumnDef="last_maintenance">
                  <th mat-header-cell *matHeaderCellDef>
                      <div class="value">
                        {{'VEHICLE.last_maintenance' | translate}}
                      </div>
                  </th>
                  <td mat-cell *matCellDef="let element">

                  </td>
                </ng-container> -->
        <!-- <ng-container matColumnDef="vehicleNumber">
                    <th mat-header-cell *matHeaderCellDef>
                        <div class="input">
                            <input type="text" [(ngModel)]="filters.vehicleNumber" [placeholder]="'VEHICLE.vehicleNo' | translate" (keyup)="searchFilter(filters.vehicleNumber, 'number');">
                            <i class="material-icons clearIcon" *ngIf="filters.vehicleNumber" (click)="filters.vehicleNumber = ''; clearFilter('number');"> clear </i>
                        </div>
                    </th>
                    <td mat-cell *matCellDef="let element">

                    </td>
                </ng-container> -->
        <ng-container matColumnDef="action">
          <th mat-header-cell *matHeaderCellDef>{{'VEHICLE.actions' | translate}}</th>
          <td mat-cell *matCellDef="let element" style="width: 100px;">
            <div class="buttons">
              <div class="button">
                <!-- removed icons as in the IOCL design - Rakshitha -->
                <mat-select [placeholder]="'VEHICLE.actions' | translate">
                  <mat-option (click)="openViewVehicle(element);"> {{'VEHICLE.view' | translate}}</mat-option>
                  <mat-option *ngIf="element.attached" (click)="openAttachDriverComponent(element, 'Detach');">
                    {{'VEHICLE.detachLab' | translate}}</mat-option>
                  <mat-option *ngIf="!element.attached && !element.maintenance"
                    (click)="openAttachDriverComponent(element, 'Attach');"> {{'VEHICLE.attachLab' | translate}}
                  </mat-option>
                  <mat-option *ngIf="!element.attached" (click)="openEditVehicleComponent(element);"> {{'VEHICLE.edit' |
                    translate}}
                  </mat-option>
                  <mat-option *ngIf="!element.maintenance"
                    (click)="$event.stopPropagation();openMarkMaintainanceDialog(element,'markIn');">
                    {{'VEHICLE.markInMaintainance' | translate}}</mat-option>
                  <mat-option *ngIf="element.maintenance"
                    (click)="$event.stopPropagation();openMarkMaintainanceDialog(element,'markOut');">
                    {{'VEHICLE.markOutMaintainance' | translate}}</mat-option>

                  <mat-option *ngIf="element.dedicated_to !== 'N/A'"
                    (click)="openDedicateVehicleToDialog(element, 'Remove');">
                    {{'VEHICLE.remove_dedicate_vehicle' | translate}}</mat-option>

                  <mat-option *ngIf="element.dedicated_to === 'N/A'"
                    (click)="$event.stopPropagation();openDedicateVehicleToDialog(element,'Add');">
                    {{'VEHICLE.dedicate_vehicle_to' | translate}}</mat-option>

                  <mat-option *ngIf="!element.cardPAN && fuel_card_feature"
                    (click)="$event.stopPropagation();openUpdateCardPAN(element, 1);">
                    Attach IOCL Card PAN
                  </mat-option>
                  <mat-option *ngIf="element.cardPAN && fuel_card_feature"
                    (click)="$event.stopPropagation();openUpdateCardPAN(element, 2);">
                    Detach IOCL Card PAN
                  </mat-option>
                  <mat-option *ngIf="element.cardPAN && fuel_card_feature"
                    (click)="$event.stopPropagation();openUpdateCardPAN(element);">
                    Update IOCL Card PAN </mat-option>

                </mat-select>
              </div>
            </div>
          </td>
        </ng-container>
        <tr mat-header-row *matHeaderRowDef="columnsToDisplay; sticky:true;"></tr>
        <tr mat-row *matRowDef="let row; columns: columnsToDisplay;"></tr>
      </table>
      <mat-paginator [length]="(vehicleList)? vehicleCount: 0" [pageSizeOptions]="[10, 25, 50, 100]"
        showFirstLastButtons [pageSize]="25" (page)="pageNavigate($event)"
        style="border-top: solid 1px #ededed; border-bottom: solid 1px #ededed;"></mat-paginator>
    </div>
    <ng-template #noVehicles>
      <div class="noVehicles">
        {{'VEHICLE.noVehLab' | translate}}
      </div>
      <div class="clearButton" *ngIf="filters.vehicleType.length || filters.vehicleNumber">
        <div class="button" (click)="clearAll();">
          Clear
        </div>
      </div>
    </ng-template>
  </div>
</div>
<ng-template #uploadDialog>
  <div class="dialogMain">
    <div class="loader" *ngIf="showLoader">
      <div class="load">
        <mat-spinner></mat-spinner>
      </div>
    </div>
    <div class="section">
      <div class="header">
        <div class="label">
          {{'VEHICLE.upload' | translate}}
          <i class="material-icons" (click)="uploadDocsRef.close();">clear</i>
        </div>
      </div>
      <div class="uploadFile">
        <input class="inputField" accept="image/*" (change)="fileChanged($event)" type="file">
      </div>
      <div class="imageTypes">
        (Only .png, .jpeg or JPG files)
      </div>
      <div class="submitButton">
        <div class="button" (click)="uploadRegDocs();">
          {{'CREATE_BILLS.submit' | translate}}
        </div>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #markMaintainance>
  <div class="dialogMain">
    <div class="loader" *ngIf="showLoader">
      <div class="load">
        <mat-spinner></mat-spinner>
      </div>
    </div>
    <div class="section">
      <div class="header">
        <div class="label">
          <span *ngIf="mark_type == 'markIn'">
            {{'VEHICLE.markInMaintainance' | translate}}
          </span>
          <span *ngIf="mark_type == 'markOut'">
            {{'VEHICLE.markOutMaintainance' | translate}}
          </span>
          <i class="material-icons" (click)="closeModal({});">clear</i>
        </div>
      </div>
      <div class="uploadFile">
        <div class="message" *ngIf="mark_type == 'markIn' && selected_vehicle_data.attached">
          {{'VEHICLE.markInMessage_attached' | translate}}
        </div>
        <div class="message" *ngIf="mark_type == 'markIn' && !selected_vehicle_data.attached">
          {{'VEHICLE.markInMessage' | translate}}
        </div>
        <div class="message" *ngIf="mark_type == 'markOut'">
          {{'VEHICLE.markOutMessage' | translate}}
        </div>
        <div *ngIf="mark_type == 'markOut'">
          <div class="label">
            {{'VEHICLE.maintainanceDueDate' | translate}}
          </div>
          <input class="inputField" [(ngModel)]="due_date_string" (dateChange)="getEpoch($event.value);"
            (click)="picker.open()" [matDatepicker]="picker" [min]="min_due_date" />
          <mat-datepicker #picker></mat-datepicker>
          <i class="material-icons calendar" style="font-size:18px;">date_range</i>
        </div>
      </div>
      <div *ngIf="showYesNo" class="submitButtonNo" (click)="closeModal({});">
        <div class="button">
          {{'VEHICLE_MAP_VIEW.no' | translate}}
        </div>
      </div>
      <div *ngIf="showYesNo" class="submitButton" (click)="markMaintainanceSubmit();">
        <div class="button">
          {{'VEHICLE_MAP_VIEW.yes' | translate}}
        </div>
      </div>
      <div *ngIf="!showYesNo" class="submitButton">
        <div class="button" (click)="markMaintainanceSubmit();">
          {{'VEHICLE_MAP_VIEW.submit' | translate}}
        </div>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #dedicateVehicleTo>
  <div class="dedicate_vehicle_dialogMain">
    <div class="loader" *ngIf="showLoader">
      <div class="load">
        <mat-spinner></mat-spinner>
      </div>
    </div>
    <div class="section">
      <div class="header">
        <div class="label">
          <span>
            {{'VEHICLE.dedicate_vehicle_to' | translate}}
          </span>
          <i class="material-icons" (click)="dedicateVehicleToRef.close();">clear</i>
        </div>
      </div>
      <div class="uploadFile">
        <div>
          <div *ngIf="isShowAddDedicatedVechicle">
            <div class="dedicate_list">
              <div class="vehicle_shipper">
                <span class="dedicate_text">{{'VEHICLE.dedicate' | translate}}</span>
                <span class="dedicate_text" style="color: #631d4f;font-weight: bold;">
                  {{vehicleNumber}}</span>
                <span class="dedicate_text">{{'VEHICLE.to' | translate}}</span>
              </div>
              <div class="input_dropdown">
                <!-- removed icons as in the IOCL design - Rakshitha -->
                <mat-select class="inputField" [(ngModel)]="shipper">
                  <mat-option *ngFor="let shipper of shippersArr" [value]="shipper._id">
                    {{ shipper.name }}
                  </mat-option>
                </mat-select>
              </div>
            </div>
          </div>
          <div *ngIf="!isShowAddDedicatedVechicle">
            <span> {{'VEHICLE.remove_info' | translate}}</span>
          </div>

        </div>
      </div>
      <div class="submit_btn">
        <div class="submitButtonNo" (click)="dedicateVehicleToRef.close();">
          <div class="button">
            {{(isShowAddDedicatedVechicle)?('VEHICLE.cancel' | translate):('VEHICLE.no' | translate)}}
          </div>
        </div>
        <div class="submitButton">
          <div class="button" (click)="dedicatedVehicleTo();">
            {{(isShowAddDedicatedVechicle)?('VEHICLE_MAP_VIEW.submit' | translate):('VEHICLE.yes' | translate)}}
          </div>
        </div>
      </div>



    </div>
  </div>
</ng-template>

<ng-template #openVideos>


  <div class="uploadDialogMain">
    <div class="header">
      <div class="label">
        {{'VEHICLE.Adding_vehicle' | translate}}
      </div>
      <div class="close">
        <span class="material-icons" (click)="VideoLinkRef.close()" style="cursor: pointer;">
          close
        </span>
      </div>
    </div>
    <div class="body">
      <div>
        <div style="
          position: relative;
          padding-bottom: 56.25%;
          height: 0;
          border-radius: 0;
          box-shadow: 0 15px 40px rgba(63,58,79,.3);
          overflow: hidden;
          min-width:320px">
          <iframe [src]="video_URL" frameborder="0" webkitallowfullscreen mozallowfullscreen allowfullscreen
            style="position: absolute; top: 0; left: 0; width: 100%; height: 100%;"></iframe>
        </div>
      </div>
    </div>
  </div>

</ng-template>